import React, { useEffect, useState } from "react";

interface ITextRendererProps {
	presignedUrl: string;
}

function htmlEscape(str: string) {
	return str
		.replace(/&/g, "&amp")
		.replace(/'/g, "&apos")
		.replace(/"/g, "&quot")
		.replace(/>/g, "&gt")
		.replace(/</g, "&lt");
}
export const TextRenderer: React.FC<ITextRendererProps> = ({ presignedUrl }) => {
	const [textContent, setTextContent] = useState("");

	useEffect(() => {
		fetch(presignedUrl)
			.then((response) => response.text())
			.then((data) => {
				setTextContent(data);
			});
	}, [presignedUrl]);

	return <pre dangerouslySetInnerHTML={{ __html: htmlEscape( textContent) }} />;
};


